import React from 'react'
import PropTypes from 'prop-types'
import { createUseStyles, useTheme } from 'react-jss'

import { isClientSide } from '../../Common/utils'
import SVG from '../../SVG/SVG'

const useStyles = createUseStyles({
    bookingSplitTitleBar: ({ bgColor, theme }) => ({
        backgroundColor: theme.colors.deepsea,
        fontFamily: theme.fontFamily,
        boxSizing: 'border-box',
        margin: '0px auto',
        // padding: "0px 25px",
        position: 'relative',
    }),
    bookingSplitTitleSectionCon: ({ bgColor, theme }) => ({
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'nowrap',
    }),
    bookingSplitTitleSection: ({ bgColor, theme }) => ({
        flex: '0 1 50%',
        boxSizing: 'border-box',
        margin: 0,
        padding: 0,
        textAlign: 'center',
        backgroundColor: theme.colors.brushedsteel,
        cursor: 'pointer',

        '&:hover': {
            backgroundColor: theme.colors.warmGrey,
        },

        '&.selected': {
            backgroundColor: theme.colors.deepsea,
            cursor: 'auto',

            '&:hover': {
                backgroundColor: theme.colors.deepsea,
            },
        },
    }),
    bookingSplitTitle: ({ bgColor, theme }) => ({
        ...theme.headings.bookingTitleBarHeading,
        color: theme.colors.white,
        margin: 0,
        paddingBottom: 17,
        paddingTop: 19,
        textAlign: 'center',
    }),
    bookingSplitToggle: ({ bgColor, theme }) => ({
        textTransform: 'uppercase',
        textAlign: 'center',
        width: 160,
        height: 30,
        padding: '5px 20px',
        borderRadius: 15,
        backgroundColor: theme.colors.white,
        border: `1px solid ${theme.colors.blue}`,
        color: theme.colors.blue,
        lineHeight: '20px',
        fontSize: 12,
        fontWeight: 700,
        position: 'absolute',
        bottom: -15,
        left: 0,
        right: 0,
        margin: 'auto',
        boxSizing: 'border-box',
        cursor: 'pointer',
        zIndex: 100,

        '& > span:nth-of-type(2)': {
            minWidth: 12,
        },

        '& > span:nth-of-type(2) svg': {
            transform: 'rotate(-90deg)',
            transition: `transform ${theme.animations.animate}`,
            marginLeft: 2,
            position: 'absolute',
            bottom: 0,
            top: 0,
            right: 10,
            margin: 'auto',
        },

        '&.is-closed > span:nth-of-type(2) svg': {
            transform: 'rotate(90deg)',
        },

        '&:hover': {
            backgroundColor: theme.colors.cloudyBlue,
        },
    }),
    bookingSplitTitleIcon: ({ bgColor, theme }) => ({
        position: 'relative',

        '& svg': {
            position: 'absolute',
            top: '-10px',
            right: '-30px',
            backgroundColor: theme.colors.white,
            borderRadius: '50%',
            padding: 5,
        },
    }),
})

const toggleFormBook = e => {
    if (isClientSide) {
        let book = document.querySelector('#formBook')
        let toggle = document.querySelector('#formBookToggle')
        let toggleText = document.querySelector('#formBookToggleText')

        if (book) {
            if (book.classList.contains('is-closed')) {
                book.classList.remove('is-closed') // Show Booking
                toggle.classList.remove('is-closed')
                toggleText.innerHTML = 'Hide Itinerary'
            } else {
                book.classList.add('is-closed') // Hide Booking
                toggle.classList.add('is-closed')
                toggleText.innerHTML = 'Change Itinerary'
            }
        }
    }
}

const BookingSplitTitleBar = ({
    bgColor,
    widgetOpen,
    widgetLocked,
    titleOne,
    titleTwo,
    trip,
    selectTrip,
    carOneSelected,
    carTwoSelected,
    tripOnePaid,
    tripTwoPaid,
}) => {
    const theme = useTheme()
    const classes = useStyles({ bgColor, theme })
    return (
        <div className={classes.bookingSplitTitleBar}>
            <div className={classes.bookingSplitTitleSectionCon}>
                <div
                    className={`${classes.bookingSplitTitleSection} ${trip == 1 ? 'selected' : ''}`}
                    onClick={e => selectTrip(1, e)}
                >
                    <h2 className={classes.bookingSplitTitle}>
                        <span className={classes.bookingSplitTitleIcon}>
                            {titleOne}
                            {tripOnePaid ? (
                                <SVG name={'Tick'} width={16} height={16} colorOne={'#009520'} />
                            ) : (
                                <SVG
                                    name={'Car'}
                                    width={16}
                                    height={16}
                                    colorOne={carOneSelected ? '#01396C' : '#FF0000'}
                                />
                            )}
                        </span>
                    </h2>
                </div>
                <div
                    className={`${classes.bookingSplitTitleSection} ${trip == 2 ? 'selected' : ''}`}
                    onClick={e => selectTrip(2, e)}
                >
                    <h2 className={classes.bookingSplitTitle}>
                        <span className={classes.bookingSplitTitleIcon}>
                            {titleTwo}
                            {tripTwoPaid ? (
                                <SVG name={'Tick'} width={16} height={16} colorOne={'#009520'} />
                            ) : (
                                <SVG
                                    name={'Car'}
                                    width={16}
                                    height={16}
                                    colorOne={carTwoSelected ? '#01396C' : '#FF0000'}
                                />
                            )}
                        </span>
                    </h2>
                </div>
            </div>
            {widgetLocked ? (
                ''
            ) : (
                <div
                    id={'formBookToggle'}
                    className={`${classes.bookingSplitToggle} ${widgetOpen ? '' : 'is-closed'}`}
                    onClick={e => toggleFormBook(e)}
                >
                    <span id={'formBookToggleText'}>
                        {widgetOpen ? 'Hide Itinerary' : 'Change Itinerary'}
                    </span>
                    <span>
                        &nbsp;
                        <SVG name={'Chevron'} width={12} height={12} colorOne={'#01396c'} />
                    </span>
                </div>
            )}
        </div>
    )
}

// BookingSplitTitleBar.propTypes = {
//     children: PropTypes.string
// }

export default BookingSplitTitleBar
